module.exports = __webpack_public_path__ + "static/media/WeeklySales.56402bdd.svg";